import {
  // useEffect,
  // useState,
  type ReactNode,
} from 'react';
// import { useLocation } from 'react-router-dom';
// import ROUTES from '@/routes/path';
// import { useAuth } from '@/utils/auth-utils';
// import Intercom, { onShow } from '@intercom/messenger-js-sdk';
// import { MessagesSquare, X } from 'lucide-react';
// import { useLayoutVisibility } from '@/utils/common-utils';

type IntercomWrapperProps = {
  children: ReactNode;
};

// Intercom is a customer messaging & support tool that allows live chat, product tours, and user engagement.
// Uncomment the code below to enable Intercom in this project.

const IntercomWrapper = ({ children }: IntercomWrapperProps) => {
  // const location = useLocation();
  // const { user, userName } = useAuth();
  // const [showBubble, setShowBubble] = useState(false);
  // const { isMobile, hasIntercom, setHasIntercom } = useLayoutVisibility();

  // useEffect(() => {
  //   const restrictedPaths = [ROUTES.autoLogin, ROUTES.beneficiarySignIn, ROUTES.login];
  //   const isRestricted = restrictedPaths.includes(location.pathname);

  //   let showBubbleTimeout: ReturnType<typeof setTimeout> | null = null;
  //   let hideBubbleTimeout: ReturnType<typeof setTimeout> | null = null;

  //   if (isRestricted || !user || isMobile) {
  //     if (window.Intercom && typeof window.Intercom === 'function') {
  //       window.Intercom('shutdown');
  //     }
  //     setShowBubble(false);
  //     setHasIntercom(false);
  //   } else if (user) {
  //     Intercom({
  //       app_id: import.meta.env.VITE_PUBLIC_INTERCOM_ID,
  //       user_id: user.uid,
  //       name: userName || 'Guest',
  //       email: user?.email || '',
  //       created_at: Math.floor(new Date().getTime() / 1000),
  //     });
  //     setHasIntercom(true);
  //     onShow(() => setShowBubble(false));
  //     showBubbleTimeout = setTimeout(() => {
  //       setShowBubble(true);
  //       hideBubbleTimeout = setTimeout(() => {
  //         setShowBubble(false);
  //       }, 14000);
  //     }, 1000);
  //   } else {
  //     setShowBubble(false);
  //   }

  //   return () => {
  //     if (showBubbleTimeout) clearTimeout(showBubbleTimeout);
  //     if (hideBubbleTimeout) clearTimeout(hideBubbleTimeout);
  //   };
  // }, [user, userName, location.pathname, isMobile, setHasIntercom]);

  return (
    <>
      {/* {hasIntercom && showBubble && (
        <div
          style={{
            position: 'fixed',
            bottom: '82px',
            right: '16px',
            zIndex: 9999,
            pointerEvents: 'auto',
          }}
          className="flex items-center gap-2 bg-[var(--lifexlight)] text-white rounded-full shadow-lg px-5 py-3 hover:shadow-xl transition-shadow relative"
        >
          <MessagesSquare />
          <span className="font-medium">Questions? Ask me anything..</span>
          <X size={18} className="cursor-pointer" onClick={() => setShowBubble(false)} />
          <span
            className="absolute right-[18px] bottom-[-10px] w-0 h-0"
            style={{
              borderLeft: '10px solid transparent',
              borderRight: '10px solid transparent',
              borderTop: '12px solid var(--lifexlight)',
            }}
          />
        </div>
      )} */}
      {children}
    </>
  );
};

export default IntercomWrapper;
